<template>
  <div id="safety">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'safety'
}
</script>


// WEBPACK FOOTER //
// src/views/exhibitorsUpload/Safety.vue